import { SamlData } from '@/models/Salm';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { Saml, SamlTypes } from './types';

export const samlRequest = (data: SamlData) => action(SamlTypes.SAML_REQUEST, data);
export const samlSuccess = (data: Saml) => action(SamlTypes.SAML_SUCCESS, { data });
export const samlFailure = (error: AxiosError) => action(SamlTypes.SAML_FAILURE, error);
